import { Injectable, OnInit } from '@angular/core';
import { DeviceIdHandlerComponent } from '../helpers/device-id-handler.component';
import { EncryptionUtil } from '../../shared/utils/encryption.util';
import { DeviceInformation } from '../../shared/models/device.model';
import { AppConfig } from '../../shared/config/app-config';
import {StringHelper} from "../helpers/strings.helper";
import {ModalService} from "../../lean-shared/components/nz-modal-service/modal.service";
import {LoginRequestModel} from "../../shared/models/login.model";
import { LocalStorageService } from './local-storage.service';
import { StorageKeys } from '../../shared/models/storage-keys';

@Injectable({
	providedIn: 'root',
})
export class DeviceHelperService extends DeviceIdHandlerComponent{
	deviceInformation: DeviceInformation;

	constructor(
		encryptUtil: EncryptionUtil,
		config: AppConfig,
		modalService: ModalService,
    localStorage: LocalStorageService) {
		super(encryptUtil, config, modalService, localStorage);
		this.initialize();
	}

	initialize(){
		this.initializeDeviceUniqueIdentifier()
			.then(() => {
				this.setDeviceInformation();
			}).catch(error => {
				console.log('error initializeDeviceUniqueIdentifier ', error);
		})
	}

	getDeviceInformation(): DeviceInformation {
		let deviceInformation = this.getDeviceInformationWithDeviceUniqueIdentifier();
    if(!deviceInformation?.deviceUniqueIdentifier){
      deviceInformation = this.getDeviceInformationFromLocalStorage();
    }
		return deviceInformation;
	}

  getDeviceInformationFromLocalStorage(): DeviceInformation{
    const deviceUniqueIdentifier = this.localStorage.get(StorageKeys.unique_device_identifier);
    if(!deviceUniqueIdentifier){return null}
    const encryptedDeviceId = this.localStorage.get(StorageKeys.encrypted_unique_device_identifier);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const client = new ClientJS();
    return {
      deviceUniqueIdentifier,
      encryptedDeviceId,
      model: client.getBrowser(),
      manufacturer: client.getOS()
    }
  }

	getDeviceInformationWithDeviceUniqueIdentifier(): DeviceInformation{
		return this.deviceInformation;
	}

	async saveDeviceInformation(device: any) {
		if (device) {
			const encryptedDeviceId = this.getEncryptedDeviceId(device?.deviceUniqueIdentifier)
			await this.saveDeviceIdToIndexDb(encryptedDeviceId);
			device.encryptedDeviceId =  encryptedDeviceId;
			this.deviceInformation = device;
		}
	}

	getWebDevice(): DeviceInformation {
		return {
			deviceUniqueIdentifier: this.deviceId,
			manufacturer: this.machineOS,
			model: this.browser,
			encryptedDeviceId: this.encryptedDeviceId,
		};
	}

	setDeviceInformation() {
		this.deviceInformation = this.getWebDevice();
	}
}
